const routeViews = {
  // Panels
  LeftPanel: 'LeftPanel',
  MiddlePanel: 'MiddlePanel',
  RightPanel: 'RightPanel',
  // Other
  Header: 'Header',
  Main: 'Main',
  Editor: 'Editor',
  MainDialog: 'MainDialog',
}

export default routeViews
